import { getRouteApi } from "@tanstack/react-router";
import { useRef, useState } from "react";
import { useDebounce } from "react-use";
import { BookingsForecast } from "../BookingsForecast";
import { BookingsTable, type BookingsTableHandle } from "../BookingsTable";
import { type BookingFilters } from "@/routes/(authed)/_layout/bookings.route";

const routeApi = getRouteApi("/(authed)/_layout/bookings");

export function Bookings() {
  const searchParams = routeApi.useSearch();
  const [filters, setFilters] = useState<BookingFilters>(searchParams);
  // Values that stay listed but are not narrowing the results. Deliberately not
  // URL-synced — see docs/adr/0001-inactive-filter-values-are-not-url-synced.md
  const [inactiveFilters, setInactiveFilters] = useState<BookingFilters>({});
  const tableRef = useRef<BookingsTableHandle>(null);
  const navigate = routeApi.useNavigate();

  // Debounced URL sync for chart filter interactions
  // Table filters handle their own URL updates via Apply button
  useDebounce(
    () => {
      const cleanFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, values]) => (Array.isArray(values) ? values.length > 0 : !!values)),
      );

      handleResetPagination();

      void navigate({ search: (prev) => ({ ...prev, ...cleanFilters }) });
    },
    300,
    [filters],
  );

  const handleResetPagination = () => {
    tableRef.current?.resetPagination();
  };

  return (
    <div className="space-y-4">
      <BookingsForecast filters={filters} setFilters={setFilters} />
      <BookingsTable
        ref={tableRef}
        filters={filters}
        setFilters={setFilters}
        inactiveFilters={inactiveFilters}
        setInactiveFilters={setInactiveFilters}
      />
    </div>
  );
}
